import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiService } from 'src/app/shared/service/api.service';

@Component({
  selector: 'app-informative-defect',
  templateUrl: './informative-defect.component.html',
  styleUrls: ['./informative-defect.component.css'],
})
export class InformativeDefectComponent implements OnInit {
  _filterAccomplish: any = {};
  @Input() set filterAccomplish(value: any) {
    this._filterAccomplish = value;
    this.filterItem(this._filterAccomplish);
  }
  @Output() errorEmitter = new EventEmitter();

  message: string = '';
  loading: boolean = true;
  itemTotalDefectDay!: any;
  itemTotalDefectDayValidation!: any;
  itemTotalDefectDaySplit!: any;
  itemTotalDefectDayTooltip!: any;

  itemTotalDefectWeek!: any;
  itemTotalDefectWeekValidation!: any;
  itemTotalDefectWeekSplit!: any;
  itemTotalDefectWeekTooltip!: any;

  itemTotalDefectMonth!: any;
  itemTotalDefectMonthValidation!: any;
  itemTotalDefectMonthSplit!: any;
  itemTotalDefectMonthTooltip!: any;

  itemTotalFin: number = 0;
  itemTotalFinValidation!: any;
  itemTotalFinSplit!: any;
  itemTotalFinTooltip!: any;
  dataLabel: string = '';

  constructor(private api: ApiService) {}

  ngOnInit(): void {}

  filterItem(item: any) {
    this.loading = true;
    this.itemTotalDefectDayValidation = null;
    this.itemTotalDefectWeekValidation = null;
    this.itemTotalDefectMonthValidation = null;
    this.defectInformationDay(item);
    this.defectInformationWeek(item);
    this.defectInformationMonth(item);
    this.finalyInformation(item);
  }

  async defectInformationDay(item: any) {
    const itemProductAux =
      item.typeProduct != '' ? item.typeProduct : [0, 1, 2, 3];

    try {
      const result = await this.api
        .getDefectPanelInformation(itemProductAux, item.branch, 'day')
        .toPromise();
      this.itemTotalDefectDayValidation = result.items;
      const value =
        parseFloat(result.items[0].finishSacrificePercentage) +
        parseFloat(result.items[0].secondQualityPercentage) +
        parseFloat(result.items[0].thirdQualityPercentage);
      this.itemTotalDefectDay = Number(value.toFixed(2));
    } catch (ex) {
      this.loading = false;
      this.formatErrorMensagem("defect-Information-Day",ex.error[0].message);
    } finally {
      if(this.itemTotalDefectDay == 0)
      {
        this.formatErrorMensagem("defect-Information-Day", "Sem informação para painel de defeito diário!");
      }
      this.loading = false;
    }
  }

  async defectInformationWeek(item: any) {
    const itemProductAux =
      item.typeProduct != '' ? item.typeProduct : [0, 1, 2, 3];

    try {
      const result = await this.api
        .getDefectPanelInformation(itemProductAux, item.branch, 'week')
        .toPromise();
      this.itemTotalDefectWeekValidation = result.items;
      const value =
        parseFloat(result.items[0].finishSacrificePercentage) +
        parseFloat(result.items[0].secondQualityPercentage) +
        parseFloat(result.items[0].thirdQualityPercentage);
      this.itemTotalDefectWeek = Number(value.toFixed(2));
    } catch (ex) {
      this.loading = false;
      this.formatErrorMensagem("defect-Information-Week",ex.error[0].message);
    } finally {
      if(this.itemTotalDefectWeek == 0)
      {
        this.formatErrorMensagem("defect-Information-Week", "Sem informação para painel de defeito semanal!");
      }
      this.loading = false;
    }
  }

  async defectInformationMonth(item: any) {
    const itemProductAux =
      item.typeProduct != '' ? item.typeProduct : [0, 1, 2, 3];

    try {
      const result = await this.api
        .getDefectPanelInformation(itemProductAux, item.branch, 'month')
        .toPromise();
      this.itemTotalDefectMonthValidation = result.items;
      const value =
        parseFloat(result.items[0].finishSacrificePercentage) +
        parseFloat(result.items[0].secondQualityPercentage) +
        parseFloat(result.items[0].thirdQualityPercentage);
      this.itemTotalDefectMonth = Number(value.toFixed(2));
    } catch (ex) {
      this.loading = false;
      this.formatErrorMensagem("defect-Information-Month", ex.error[0].message);
    } finally {
      if(this.itemTotalDefectMonth == 0)
      {
        this.formatErrorMensagem("defect-Information-Month", "Sem informação para painel de defeito mensal!");
      }
      this.loading = false;
    }
  }

  async finalyInformation(item: any) {
    this.itemTotalFin = 0;
    const itemProductAux =
      item.typeProduct != '' ? item.typeProduct : [0, 1, 2, 3];
    if (item.typeClassification == '') {
      this.loading = false;
      return;
    }

    try {
      const result = await this.api
        .getFinalyOrderClassDayNormal(
          item.dataMin,
          item.dataMax,
          Number(item.typeClassification),
          itemProductAux,
          item.branch
        )
        .toPromise();
      var dataMin = new Date(item.dataMin);
      dataMin.setDate(dataMin.getDate() + 1);
      var dataMax = new Date(item.dataMax);
      dataMax.setDate(dataMax.getDate() + 1);
      this.dataLabel =
        dataMin.toLocaleDateString() + ' a ' + dataMax.toLocaleDateString();
      result.items.forEach(
        (a: any) => (this.itemTotalFin += Number(a.totalQuantity))
      );
      this.itemTotalFinValidation = result;

      this.loading = false;
    } catch (ex) {
      this.loading = false;
      this.formatErrorMensagem("panel-Information-Totals", ex.error[0].message);
    } finally {
      if(this.itemTotalFinValidation.length == 0)
      {
        this.formatErrorMensagem("panel-Information-Totals", "Sem informação para painel de total de finalização!");
      }
      this.loading = false;
    }
  }

  formatErrorMensagem(panelName: string, item: any) {
    let dataError = new Date();
    let errorMensagem = "Arquivo: " + panelName + " \r\n" + "Data: " + dataError + "\r\n" + "Mensagem: " + item + "\r\n" + "===============================================" + "\r\n";
    this.errorEmitter.emit(errorMensagem);
  }
}
